import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, Typography } from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";

import Modal from "components/common/modals/modal/Modal";
import Loading from "components/common/loading/Loading";
import LoadingModal from "components/common/loading/LoadingModal";
import Doctor from "components/pages/dashboard/doctor_analytic/Doctor";
import EmptyDoctor from "components/pages/dashboard/doctor_analytic/EmptyDoctor";

import NameFilter from "components/pages/dashboard/doctor_analytic/filter/name_filter/NameFilter";
import SortFilter from "components/pages/dashboard/doctor_analytic/filter/sort_filter/SortFilter";
import AccountFilter from "components/pages/dashboard/doctor_analytic/filter/account_filter/AccountFilter";

import {
  changeFilter,
  resetFilter,
} from "app/store/dashboard/doctor_analytic/slice/doctorAnalyticSlice";
import { useDownloadReportMutation } from "app/store/dashboard/doctor_analytic/api/doctorAnalyticApi";
import { getFormattedDate } from "utils/date";
import { DATE_FORMAT } from "static/date";
import DateRangeFilter from "components/common/filters/daterange/DateRangeFilter";
import { filterNonUCHAccounts } from "utils/account.util";
import { getCurrentUserRole } from "utils/currentUser.util";
import { EVOKE_ROLES } from "static/constants";

const DoctorAnalyticModal = ({ data, isLoading }) => {
  const { startDate, endDate, account, sort, name } = useSelector(
    (state) => state.doctorAnalytic
  );
  const [downloadReport, { isLoading: isDownloading }] =
    useDownloadReportMutation();

  const dispatch = useDispatch();
  const onCloseModal = () => dispatch(resetFilter());

  const userRole = getCurrentUserRole();
  const { accounts } = useSelector((state) => state.account);
  const filteredAccounts = filterNonUCHAccounts(accounts);

  useEffect(() => {
    if (filteredAccounts?.length === 1 && !EVOKE_ROLES.includes(userRole)) {
      dispatch(
        changeFilter({
          type: "account",
          value: filteredAccounts?.[0]?.name,
        })
      );
    }
  }, [accounts, filteredAccounts, userRole, dispatch]);

  return (
    <div>
      <Modal
        buttonTitle="View All"
        modalTitle="Doctors - Signed Transmissions"
        maxWidth="xl"
        buttonStyle={{ color: "#94BA33" }}
        onClose={onCloseModal}
        content={
          <>
            <Grid container alignItems="center" marginBottom={2} spacing={2}>
              <Grid container item columnSpacing={2} lg={4}>
                <DateRangeFilter
                  startDate={startDate}
                  endDate={endDate}
                  handleStartDate={(date) => {
                    dispatch(
                      changeFilter({
                        type: "startDate",
                        value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
                      })
                    );
                  }}
                  handleEndDate={(date) => {
                    dispatch(
                      changeFilter({
                        type: "endDate",
                        value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
                      })
                    );
                  }}
                  style={{
                    width: "100%",
                  }}
                  startGridProps={{ xs: 12, sm: 6 }}
                  endGridProps={{ xs: 12, sm: 6 }}
                />
              </Grid>
              <Grid container item lg={8} columnSpacing={2}>
                <Grid item xs={12} sm={4} md={4}>
                  <AccountFilter />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <SortFilter />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <NameFilter />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              marginBottom={2}
              spacing={1}
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography paragraph style={{ color: "#757575" }} margin={0}>
                  Showing {data?.length} results
                </Typography>
              </Grid>
              {isDownloading && (
                <LoadingModal
                  open={isDownloading}
                  loadingText="Downloading..."
                />
              )}
              <Grid item>
                <Button
                  variant="outlined"
                  color="success"
                  disabled={data?.length === 0 || isDownloading}
                  sx={{ color: "#94BA33 ", borderColor: "#94BA33" }}
                  startIcon={<DownloadIcon />}
                  onClick={() =>
                    downloadReport({
                      startDate,
                      endDate,
                      account,
                      sort,
                      name,
                      isExport: true,
                    })
                  }
                >
                  Download report
                </Button>
              </Grid>
            </Grid>
            <Grid container flexDirection="row" spacing={2}>
              {isLoading ? (
                <Loading height="300px" />
              ) : data.length > 0 ? (
                data.map(({ name, report }, index) => (
                  <Grid key={index} container item md={4} marginBottom={3}>
                    <Doctor name={name} report={report} isRow={true} />
                  </Grid>
                ))
              ) : (
                <EmptyDoctor />
              )}
            </Grid>
          </>
        }
      />
    </div>
  );
};

export default DoctorAnalyticModal;
